<template>
  <div class="cad-root">

    <!-- Nav -->
    <nav class="cad-nav">
      <router-link to="/" class="cad-nav-logo" style="text-decoration:none">
        <img :src="require('@/assets/images/logo/vslbooster-logo-dark.svg')" alt="VSLBooster" style="height:40px;width:auto;display:block" />
      </router-link>
      <div class="cad-nav-right">
        <span class="cad-nav-hint">Já tem conta?</span>
        <router-link to="/login" class="cad-nav-link">Entrar →</router-link>
      </div>
    </nav>

    <div class="cad-page">

      <!-- Left: Form -->
      <div class="cad-form-side">
        <div class="cad-form-wrap">

          <div class="cad-badge">✓ 30 DIAS GRÁTIS · SEM CARTÃO</div>

          <div v-if="!done">
            <h1 class="cad-title">Teste <span class="cad-orange">grátis por 30 dias</span></h1>
            <p class="cad-sub">Crie sua conta em segundos. Acesso completo a todas as funcionalidades. <router-link to="/login" class="cad-sub-link">Já tem conta?</router-link></p>

            <div class="cad-row">
              <div class="cad-field">
                <label class="cad-label">Nome</label>
                <input v-model="form.nome" type="text" class="cad-input" placeholder="Seu nome" />
              </div>
              <div class="cad-field">
                <label class="cad-label">Sobrenome</label>
                <input v-model="form.sobrenome" type="text" class="cad-input" placeholder="Seu sobrenome" />
              </div>
            </div>

            <div class="cad-field">
              <label class="cad-label">E-mail</label>
              <div class="cad-input-wrap">
                <svg class="cad-iico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
                <input ref="emailInput" v-model="form.email" type="email" class="cad-input cad-input-pl" placeholder="você@empresa.com" :class="{ 'cad-input-error': erroTipo === 'email_exists' || erroTipo === 'email_invalid' }" />
              </div>
            </div>

            <div class="cad-field">
              <label class="cad-label">WhatsApp</label>
              <div class="cad-input-wrap">
                <svg class="cad-iico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6.09 6.09l.98-.98a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.73 16.92z"/></svg>
                <input v-model="form.phone" type="tel" class="cad-input cad-input-pl" placeholder="(11) 99999-9999" />
              </div>
            </div>

            <div class="cad-field">
              <label class="cad-label">Criar senha</label>
              <div class="cad-input-wrap">
                <svg class="cad-iico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                <input v-model="form.password" :type="showPassword ? 'text' : 'password'" class="cad-input cad-input-pl cad-input-pr" placeholder="Mínimo 8 caracteres" />
                <button type="button" class="cad-eye" @click="showPassword = !showPassword" tabindex="-1">
                  <svg v-if="!showPassword" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                  <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                </button>
              </div>
              <div class="cad-strength">
                <div class="cad-strength-bars">
                  <div v-for="i in 4" :key="i" class="cad-sbar" :class="i <= strengthLevel ? 'cad-sbar-on' : ''"></div>
                </div>
                <span class="cad-strength-lbl">{{ strengthLabel }}</span>
              </div>
            </div>

            <div v-if="erro" class="cad-erro-box">
              <p class="cad-erro-msg">{{ erro }}</p>
              <router-link v-if="erroTipo === 'email_exists'" to="/login" class="cad-erro-action">Ir para o login →</router-link>
              <button v-else-if="erroTipo === 'email_invalid'" class="cad-erro-action" @click="form.email = ''; $nextTick(() => $refs.emailInput.focus())">Corrigir email</button>
            </div>

            <button type="button" class="cad-btn" @click="cadastrar" :disabled="loading">
              {{ loading ? 'Criando sua conta...' : 'Começar agora grátis →' }}
            </button>

            <div class="cad-ssl">🔒 Seus dados estão seguros · SSL 256-bit</div>

            <p class="cad-terms">
              Ao criar sua conta, você concorda com os
              <a href="#" target="_blank">Termos de Uso</a> e
              <a href="#" target="_blank">Política de Privacidade</a>.
            </p>
          </div>

          <div v-else class="cad-success">
            <div class="cad-success-icon">🚀</div>
            <h2 class="cad-success-title">Conta criada com sucesso!</h2>
            <p class="cad-success-sub">Sua conta está pronta. Você tem 30 dias para testar todas as funcionalidades.</p>
            <router-link to="/login" class="cad-btn" style="display:block;text-align:center;text-decoration:none;">Fazer login</router-link>
          </div>

        </div>
      </div>

      <!-- Right: Visual -->
      <div class="cad-visual-side">
        <div class="cad-visual-content">
          <h2 class="cad-visual-title">Tudo que você precisa pra <span class="cad-orange">converter mais com vídeo</span></h2>
          <p class="cad-visual-sub">7 ferramentas integradas. Uma única plataforma. Zero cartão de crédito nos primeiros 30 dias.</p>
          <div class="cad-features">
            <div class="cad-feature" v-for="f in features" :key="f.title">
              <div class="cad-feature-icon">{{ f.icon }}</div>
              <div>
                <div class="cad-feature-title">{{ f.title }}</div>
                <div class="cad-feature-desc">{{ f.desc }}</div>
              </div>
            </div>
          </div>
          <div class="cad-social-proof">
            <div class="cad-avatars">
              <div v-for="(c, i) in ['#E86A10','#3B82F6','#10B981','#F5B935']" :key="i" class="cad-av" :style="{ background: c }" />
            </div>
            <span>+3.400 produtores gerando resultado agora mesmo</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Cadastro',
  metaInfo: {
    title: 'Criar Conta Grátis | VSLBooster — 30 Dias de Teste',
    titleTemplate: '%s',
    meta: [
      { name: 'description', content: 'Crie sua conta grátis no VSLBooster. 30 dias de teste sem cartão de crédito. Player anti-skip, chat com IA, analytics, mapa de calor e webinário.' },
      { property: 'og:title', content: 'Teste Grátis por 30 Dias | VSLBooster' },
      { property: 'og:description', content: 'Acesso completo a todas as funcionalidades. Sem cartão de crédito. Crie sua conta em segundos.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:site_name', content: 'VSLBooster' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Teste Grátis por 30 Dias | VSLBooster' },
      { name: 'twitter:description', content: 'Crie sua conta grátis no VSLBooster. 30 dias sem cartão de crédito.' },
    ],
    link: [
      { rel: 'canonical', href: 'https://app.vslbooster.com/cadastro-trial' },
    ],
  },
  data() {
    return {
      form: { nome: '', sobrenome: '', email: '', phone: '', password: '' },
      utmParams: {},
      loading: false,
      erro: '',
      erroTipo: '',
      done: false,
      showPassword: false,
      features: [
        { icon: '▶️', title: 'Player anti-skip', desc: 'Controle o que o lead pode pular. Retenção média de 92%.' },
        { icon: '🤖', title: 'Chat com IA', desc: 'Responda visitantes automaticamente. Capture 3× mais leads.' },
        { icon: '📡', title: 'Webinário ao vivo', desc: 'Grave uma vez, transmita ao vivo infinitas vezes.' },
        { icon: '🔥', title: 'Mapa de calor', desc: 'Veja onde o lead clica e até onde desce na página.' },
        { icon: '📊', title: 'Analytics com IA', desc: 'Sugestões automáticas: "mova o CTA pra 3:45 → +12%".' },
      ],
    }
  },
  computed: {
    strengthLevel() {
      const p = this.form.password
      if (!p) return 0
      let score = 0
      if (p.length >= 6) score++
      if (p.length >= 10) score++
      if (/[A-Z]/.test(p) || /[0-9]/.test(p)) score++
      if (/[^A-Za-z0-9]/.test(p)) score++
      return Math.min(score, 4)
    },
    strengthLabel() {
      return ['', 'Fraca', 'Razoável', 'Boa', 'Forte'][this.strengthLevel] || ''
    },
  },
  created() {
    const params = new URLSearchParams(window.location.search)
    this.utmParams = {
      utm_source: params.get('utm_source') || null,
      utm_medium: params.get('utm_medium') || null,
      utm_campaign: params.get('utm_campaign') || null,
      utm_content: params.get('utm_content') || null,
      utm_term: params.get('utm_term') || null,
      gclid: params.get('gclid') || null,
      fbclid: params.get('fbclid') || null,
    }
  },
  methods: {
    api() { return (process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend').replace(/\/$/, '') },
    async cadastrar() {
      this.erro = ''
      this.erroTipo = ''

      if (!this.form.nome) { this.erro = 'Informe seu nome para continuar.'; this.erroTipo = 'validation'; return }
      if (!this.form.sobrenome) { this.erro = 'Informe seu sobrenome para continuar.'; this.erroTipo = 'validation'; return }
      if (!this.form.email) { this.erro = 'Informe seu email para criarmos sua conta.'; this.erroTipo = 'validation'; return }
      if (!this.form.phone) { this.erro = 'Informe seu WhatsApp. Usamos apenas para suporte.'; this.erroTipo = 'validation'; return }
      if (!this.form.password || this.form.password.length < 6) { this.erro = 'Crie uma senha com pelo menos 6 caracteres.'; this.erroTipo = 'validation'; return }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(this.form.email)) {
        this.erro = 'O email informado parece incorreto. Verifique e tente novamente.'
        this.erroTipo = 'email_invalid'
        return
      }

      this.loading = true
      try {
        const resp = await fetch(`${this.api()}/cadNovoCliente`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
          },
          body: JSON.stringify({
            user_name: this.form.nome,
            user_sobrenome: this.form.sobrenome,
            user_email: this.form.email.trim().toLowerCase(),
            user_phone: this.form.phone,
            user_password: this.form.password,
            user_role: 'client',
            user_ativo: 1,
            utm_source: this.utmParams.utm_source,
            utm_medium: this.utmParams.utm_medium,
            utm_campaign: this.utmParams.utm_campaign,
            utm_content: this.utmParams.utm_content,
            utm_term: this.utmParams.utm_term,
            gclid: this.utmParams.gclid,
            fbclid: this.utmParams.fbclid,
          }),
        })

        const respClone = resp.clone()

        let data = null
        try {
          data = await resp.json()
        } catch (_) {
          try {
            const txt = await respClone.text()
            console.error('[Cadastro] Resposta não-JSON (status=' + resp.status + '):', txt.substring(0, 300))
          } catch (_2) {}
          this.erro = 'Erro de comunicação com o servidor (status ' + resp.status + '). Verifique sua conexão e tente novamente.'
          this.erroTipo = 'network'
          return
        }

        if (resp.ok && data && data.id) {
          this.done = true
          return
        }

        if (resp.status === 409) {
          this.erro = `Já existe uma conta com o email ${this.form.email}. Faça login ou recupere sua senha.`
          this.erroTipo = 'email_exists'
        } else if (resp.status === 400 && data && data.error && data.error.includes('email')) {
          this.erro = 'O email informado não é válido ou não foi possível verificá-lo. Tente outro email.'
          this.erroTipo = 'email_invalid'
        } else if (resp.status === 400 && data && data.errors) {
          this.erro = Array.isArray(data.errors) ? data.errors.join('. ') : 'Verifique os campos e tente novamente.'
          this.erroTipo = 'validation'
        } else if (resp.status >= 500) {
          this.erro = 'Nosso servidor está com um problema temporário. Tente novamente em alguns instantes.'
          this.erroTipo = 'server'
        } else {
          this.erro = (data && (data.error || data.message)) || 'Não foi possível criar sua conta. Tente novamente.'
          this.erroTipo = 'server'
        }
      } catch (e) {
        this.erro = 'Falha na conexão. Verifique sua internet e tente novamente.'
        this.erroTipo = 'network'
      } finally {
        this.loading = false
        if (this.erro && this.form.email) {
          this.reportFailedSignup()
        }
      }
    },
    reportFailedSignup() {
      try {
        const params = new URLSearchParams(window.location.search)
        fetch(`${this.api()}/failed-signup`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: [this.form.nome, this.form.sobrenome].filter(Boolean).join(' '),
            email: this.form.email,
            phone: this.form.phone,
            error_type: this.erroTipo,
            error_message: this.erro,
            page_url: window.location.href,
            utm_source: params.get('utm_source'),
            utm_medium: params.get('utm_medium'),
            utm_campaign: params.get('utm_campaign'),
            utm_content: params.get('utm_content'),
            utm_term: params.get('utm_term'),
          }),
        }).catch(() => {})
      } catch {}
    },
  },
}
</script>

<style scoped>
* { box-sizing: border-box; }

.cad-root {
  min-height: 100vh;
  background: #080d14;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  display: flex;
  flex-direction: column;
}

/* ── NAV ── */
.cad-nav {
  display: flex; align-items: center; justify-content: space-between;
  padding: 12px 40px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
  flex-shrink: 0;
}
.cad-nav-right { display: flex; align-items: center; gap: 8px; }
.cad-nav-hint { color: rgba(255,255,255,0.45); font-size: 14px; }
.cad-nav-link { color: #E86A10; font-size: 14px; font-weight: 700; text-decoration: none; }
.cad-nav-link:hover { opacity: 0.8; }

/* ── PAGE SPLIT ── */
.cad-page {
  display: flex;
  flex: 1;
  overflow: hidden;
}

/* ── LEFT: FORM ── */
.cad-form-side {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 24px;
  background: #0a1018;
  overflow-y: auto;
}
.cad-form-wrap {
  width: 100%; max-width: 440px;
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 20px;
  padding: 24px 28px;
}

.cad-badge {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 5px 12px; border-radius: 999px; margin-bottom: 14px;
  background: rgba(16,185,129,0.1); border: 1px solid rgba(16,185,129,0.3);
  color: #10B981; font-size: 11px; font-weight: 800; letter-spacing: 0.4px;
}
.cad-orange { color: #E86A10; }
.cad-title { font-size: 22px; font-weight: 900; color: #fff; letter-spacing: -0.8px; margin: 0 0 6px; line-height: 1.15; }
.cad-sub { font-size: 13px; color: rgba(255,255,255,0.55); margin: 0 0 18px; line-height: 1.5; }
.cad-sub-link { color: #E86A10; font-weight: 700; text-decoration: none; }
.cad-sub-link:hover { opacity: 0.8; }

.cad-row { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
.cad-field { margin-bottom: 10px; }
.cad-label { display: block; font-size: 11px; font-weight: 600; color: rgba(255,255,255,0.7); margin-bottom: 4px; }

.cad-input-wrap { position: relative; display: flex; align-items: center; }
.cad-iico {
  position: absolute; left: 14px; width: 16px; height: 16px;
  color: rgba(255,255,255,0.3); pointer-events: none; flex-shrink: 0;
}
.cad-eye {
  position: absolute; right: 12px;
  background: none; border: none; cursor: pointer; padding: 4px;
  color: rgba(255,255,255,0.35); display: flex; align-items: center;
}
.cad-eye:hover { color: rgba(255,255,255,0.7); }

.cad-input {
  width: 100%; padding: 10px 14px;
  background: rgba(255,255,255,0.05);
  border: 1.5px solid rgba(255,255,255,0.1);
  border-radius: 10px;
  font-size: 13px; color: #fff;
  outline: none; transition: border-color 0.2s, box-shadow 0.2s;
  font-family: inherit;
}
.cad-input-pl { padding-left: 42px; }
.cad-input-pr { padding-right: 40px; }
.cad-input::placeholder { color: rgba(255,255,255,0.25); }
.cad-input:focus { border-color: #E86A10; box-shadow: 0 0 0 3px rgba(232,106,16,0.15); }
.cad-input-error { border-color: #EF4444 !important; box-shadow: 0 0 0 3px rgba(239,68,68,0.1) !important; }

/* Strength */
.cad-strength { display: flex; align-items: center; gap: 8px; margin-top: 8px; }
.cad-strength-bars { display: flex; gap: 4px; flex: 1; }
.cad-sbar { flex: 1; height: 3px; border-radius: 2px; background: rgba(255,255,255,0.1); transition: background 0.3s; }
.cad-sbar-on { background: #E86A10; }
.cad-strength-lbl { font-size: 11px; color: rgba(255,255,255,0.4); white-space: nowrap; }

/* Error */
.cad-erro-box { background: rgba(239,68,68,0.08); border: 1px solid rgba(239,68,68,0.25); border-radius: 10px; padding: 14px 16px; margin-bottom: 14px; }
.cad-erro-msg { color: #FCA5A5; font-size: 13px; font-weight: 500; margin: 0 0 8px; line-height: 1.5; }
.cad-erro-action { display: inline-block; background: #E86A10; color: #fff; padding: 7px 16px; border-radius: 8px; font-size: 13px; font-weight: 700; text-decoration: none; border: none; cursor: pointer; }

.cad-btn {
  width: 100%; padding: 12px;
  border: none; border-radius: 12px;
  background: linear-gradient(135deg, #E86A10, #d45e0c);
  color: #fff; font-size: 14px; font-weight: 800;
  cursor: pointer; font-family: inherit;
  box-shadow: 0 6px 20px rgba(232,106,16,0.3);
  transition: all 0.2s; letter-spacing: -0.2px;
  margin-top: 6px;
}
.cad-btn:hover { transform: translateY(-1px); box-shadow: 0 10px 28px rgba(232,106,16,0.4); }
.cad-btn:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }

.cad-ssl { text-align: center; font-size: 11px; color: #10B981; margin-top: 8px; font-weight: 600; }
.cad-terms { font-size: 10px; color: rgba(255,255,255,0.3); text-align: center; margin-top: 10px; line-height: 1.5; }
.cad-terms a { color: #E86A10; text-decoration: none; }

/* Success */
.cad-success { text-align: center; padding: 24px 0; }
.cad-success-icon { font-size: 56px; margin-bottom: 16px; }
.cad-success-title { font-size: 22px; font-weight: 800; color: #fff; margin: 0 0 8px; }
.cad-success-sub { font-size: 14px; color: rgba(255,255,255,0.5); margin: 0 0 28px; line-height: 1.6; }

/* ── RIGHT: VISUAL ── */
.cad-visual-side {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 40px;
  background: linear-gradient(160deg, #0D1B2E 0%, #0a2240 60%, #06192e 100%);
  position: relative;
  overflow: hidden;
}
.cad-visual-side::before {
  content: '';
  position: absolute; top: -100px; right: -100px;
  width: 400px; height: 400px; border-radius: 50%;
  background: rgba(232,106,16,0.08);
  filter: blur(60px);
  pointer-events: none;
}
.cad-visual-content { position: relative; max-width: 460px; }
.cad-visual-title { font-size: 30px; font-weight: 900; color: #fff; letter-spacing: -1.2px; line-height: 1.1; margin: 0 0 12px; }
.cad-visual-sub { font-size: 14px; color: rgba(255,255,255,0.5); margin: 0 0 24px; line-height: 1.5; }

.cad-features { display: flex; flex-direction: column; gap: 14px; margin-bottom: 24px; }
.cad-feature { display: flex; align-items: flex-start; gap: 12px; }
.cad-feature-icon {
  font-size: 16px; flex-shrink: 0;
  width: 36px; height: 36px; border-radius: 8px;
  background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.08);
  display: flex; align-items: center; justify-content: center;
}
.cad-feature-title { font-size: 13px; font-weight: 700; color: #fff; margin-bottom: 1px; }
.cad-feature-desc { font-size: 12px; color: rgba(255,255,255,0.45); line-height: 1.4; }

.cad-social-proof { display: flex; align-items: center; gap: 12px; color: rgba(255,255,255,0.45); font-size: 12px; }
.cad-avatars { display: flex; }
.cad-av { width: 28px; height: 28px; border-radius: 50%; margin-left: -8px; border: 2px solid #0D1B2E; }
.cad-av:first-child { margin-left: 0; }

/* ── RESPONSIVE ── */
@media (max-width: 900px) {
  .cad-page { flex-direction: column; }
  .cad-visual-side { display: none; }
  .cad-form-side { padding: 24px 16px; }
  .cad-nav { padding: 14px 20px; }
}
@media (max-width: 480px) {
  .cad-form-wrap { padding: 24px 20px; }
  .cad-title { font-size: 22px; }
  .cad-row { grid-template-columns: 1fr; }
}
</style>
